import { Icon, InformativeModal } from '@amili-v3/amili-v3-design';
import { useTranslation } from 'react-i18next';

const TwoFactorAuthenConfirm = () => {
  const { t } = useTranslation();

  return (
    <InformativeModal
      centered
      open={true}
      mask={false}
      footer={[]}
      icon={<Icon name="lock" width={30} height={36} />}
      layout="vertical"
      title={t('authentication.twoFactorAuthentication')}
    >
      {t('authentication.twoFactorHelp')}
    </InformativeModal>
  );
};

export default TwoFactorAuthenConfirm;
